// extracted by mini-css-extract-plugin
export default {"privacyOverlay":"privacy-module-privacyOverlay-yf1rd"};